import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { SetLogout } from '../../../Shared-ui/Store/AuthReducer/AuthActions'

const Logout = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { isLogin } = useSelector((state:any) => state.AccountReducer)
    useEffect(() => {
        dispatch(SetLogout())
        navigate('/login', { replace: true })
    }, [])
    return (
        <div></div>
    )
}

export default Logout